var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerifiedUser = function SvgVerifiedUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.19 2.02052L4.19 5.13052C3.47 5.45052 3 6.17052 3 6.96052V11.6605C3 17.2105 6.84 22.4005 12 23.6605C17.16 22.4005 21 17.2105 21 11.6605V6.96052C21 6.17052 20.53 5.45052 19.81 5.13052L12.81 2.02052C12.3 1.79052 11.7 1.79052 11.19 2.02052ZM9.29 16.9505L6.7 14.3605C6.31 13.9705 6.31 13.3405 6.7 12.9505C7.09 12.5605 7.72 12.5605 8.11 12.9505L10 14.8305L15.88 8.95052C16.27 8.56052 16.9 8.56052 17.29 8.95052C17.68 9.34052 17.68 9.97052 17.29 10.3605L10.7 16.9505C10.32 17.3405 9.68 17.3405 9.29 16.9505Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerifiedUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verified-user.69e021d906e2ae8724fa895425788230.svg";